<!--suppress HtmlUnknownBooleanAttribute, AngularUndefinedBinding, AngularUndefinedBinding, AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item"><a href="javascript:void(0);" translate>{{ 'Orders' | translate }}</a></li>
    <li class="breadcrumb-item"><a href="javascript:void(0);" translate>{{ 'Orders List' | translate }}</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>{{ statusLabel | translate }}</li>
    <li class="breadcrumb-item">
      <a href="https://www.youtube.com/watch?v=ajQAeuuaSOE" target="_blank">
        <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
          <g id="Group">
            <path id="Path" fill="#06209f" stroke="none"
                  d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
          </g>
          <g id="g1"/>
        </svg>
      </a>
    </li>
  </ol>
</nav>
<div [hidden]="loading" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
  <div class="doc-container">
    <div class="tab-title">
      <div class="row">
        <div class="col-md-12 col-sm-12 col-12">
          <div>
            <input type="text" #searchInput class="form-control" (keypress)="filterInvoices()" (keyup)="filterInvoices()" placeholder="{{'Search' | translate}} ...">
          </div>
          <div class="scrollable-invoice-list">
            <ul *ngIf="ordersList" class="nav nav-pills inv-list-container d-block" id="pills-tab" role="tablist" #invoicesList (scroll)="onScrollInvoices()">
              <li *ngFor="let o of ordersList" class="nav-item invoice-list-item">
                <a (click)="selectOrder(o)">
                  <div class="nav-link list-actions" [id]="'invoice-' + o.orderDetails.orderNumber">
                    <div class="f-m-body">
                      <div class="f-head">
                        <div [id]="'loading-invoice-' + o.orderDetails.orderNumber" class="mx-auto spinner-grow text-info align-self-center loader-lg d-none loading-invoice"></div>
                        <svg [id]="'icon-invoice-' + o.orderDetails.orderNumber" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-dollar-sign icon-invoice">
                          <line x1="12" y1="1" x2="12" y2="23"></line>
                          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
                        </svg>
                      </div>
                      <div class="f-body">
                        <p class="invoice-number">{{ 'Invoice No' | translate }} {{ o.orderDetails.orderNumber }}</p>
                        <p *ngIf="o.externalOrderNumber" class="invoice-number" style="max-width: 100px">{{ 'Merchant Order#' | translate }} {{ o.externalOrderNumber.trim() }}</p>
                        <p class="invoice-customer-name"><span>{{ 'To' | translate }}: </span>{{ o.clientDetails.name }}</p>
                        <p class="invoice-generated-date">{{ 'Date' | translate }}: {{ o.orderDetails.createDate }}</p>
                        <p class="invoice-generated-date">{{ 'Amount' | translate }}: {{ o.orderDetails.amount }} <img src="assets/sr.svg" height="18"/></p>
                        <p class="invoice-generated-date">{{ 'Status' | translate }}: <span [ngClass]="getStatusStyle(o.orderDetails.orderStatus)">{{ getStatus(o.orderDetails.orderStatus) }}</span></p>
                        <p class="invoice-generated-date">{{ 'Type' | translate }}: <span [ngClass]="getStatusStyle(o.orderDetails.orderStatus)">{{ getPaymentMethod(o.orderDetails.paymentNote) }}</span></p>
                      </div>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
            <div *ngIf="loadingMore">
              <div class="d-flex">
                <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
              </div>
            </div>
          </div>
          <div *ngIf="ordersList == null && !loadingMore">
            <div class="d-flex">
              <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="invoice-container">
      <div class="invoice-inbox">
        <!-- Empty black screen for not selected invoice -->
        <div class="inv-not-selected" *ngIf="!selectedOrder">
          <p>{{ 'Open an invoice from the list' | translate }}</p>
        </div>

        <!-- invoice header -->
        <div class="invoice-header-section">
          <h4 class="inv-number"></h4>
          <div class="invoice-action">
            <div class="dropdown custom-dropdown">
              <a #dropdownToggle class="dropdown-toggle2" href="#" role="button" [id]="'dropdownMenuLink'" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </a>
              <div class="dropdown-menu" [attr.aria-labelledby]="'dropdownMenuLink'" style="will-change: transform;">
                <a class="dropdown-item" href="javascript:void(0);" (click)="shareOrder()" translate>Share Order</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="printOrder()" translate>Print VAT Invoice</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="printReceipt()" translate>Print Receipt</a>
                <a id="cancelAnchor" *ngIf="selectedOrder && selectedOrder.orderDetails.orderStatus === 'PENDING' && !isAccountant" class="dropdown-item" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#cancelModal'" translate>Cancel Order</a>
                <a *ngIf="selectedOrder && !isAccountant && (selectedOrder.orderDetails.orderStatus === 'PAID_LINK' || selectedOrder.orderDetails.orderStatus === 'PAID')" class="dropdown-item" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#sentModal'" translate>Products sent to customer</a>
                <a *ngIf="selectedOrder && !isAccountant && (selectedOrder.orderDetails.orderStatus === 'PAID_LINK' || selectedOrder.orderDetails.orderStatus === 'PAID' || selectedOrder.orderDetails.orderStatus === 'COMPLETED_ORDER' || selectedOrder.orderDetails.orderStatus === 'COMPLETED_INVOICE')" class="dropdown-item" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#refundModal'" translate>Refund the order</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Page to display invoice details. -->
        <div *ngIf="selectedOrder != null && selectedOrder.orderDetails != null">
          <div [ngClass]="'invoice-' + selectedOrder.orderDetails.orderNumber">
            <div class="content-section  animated animatedFadeInUp fadeInUp">
              <div class="row inv--head-section">
                <div class="col-sm-6 col-12">
                  <h3 class="in-heading">{{ 'INVOICE' | translate }}</h3>
                </div>
                <div class="col-sm-6 col-12 align-self-center text-sm-right">
                  <div class="company-info">
                    <img width="80" [src]="env.getRest() + '/openApi/loadMerchantImage/' + selectedOrder.merchantDetails.id + '/80/80'" alt="Merchant image"/>
                  </div>
                </div>
              </div>
              <div class="row inv--detail-section">
                <div class="col-sm-7 align-self-start">
                  <span class="text-danger" *ngIf="selectedOrder && selectedOrder.refundPrice == -1000.00 && !isAccountant && (selectedOrder.orderDetails.orderStatus === 'PAID_LINK' || selectedOrder.orderDetails.orderStatus === 'PAID' || selectedOrder.orderDetails.orderStatus === 'COMPLETED_ORDER' || selectedOrder.orderDetails.orderStatus === 'COMPLETED_INVOICE')" translate>Order under refunding process.</span>
                  <p class="inv-to">{{ 'Invoice To' | translate }}</p>
                </div>
                <div class="col-sm-5 align-self-start text-sm-right order-sm-0 order-1">
                  <p class="inv-detail-title">{{ 'From' | translate }} : {{ selectedOrder.merchantDetails.shopName }}</p>
                </div>

                <div class="col-sm-7 align-self-start">
                  <p class="inv-customer-name">{{ selectedOrder.clientDetails.name }}</p>
                  <p class="inv-street-addr" *ngIf="selectedOrder?.clientAddress?.city">{{ selectedOrder?.clientAddress?.city }} {{ selectedOrder?.clientAddress?.address }}</p>
                  <p class="inv-email-address" dir="ltr">{{ selectedOrder.clientDetails.mobile }}</p>
                </div>
                <div class="col-sm-5 align-self-start  text-sm-right order-2">
                  <p class="inv-list-number"><span class="inv-title">{{ 'Invoice Number' | translate }} : </span> <span class="inv-number">{{ selectedOrder.orderDetails.orderNumber }}</span></p>
                  <p class="inv-created-date"><span class="inv-title">{{ 'Invoice Date' | translate }} : </span> <span class="inv-date">{{ selectedOrder.orderDetails.createDate }}</span></p>
                </div>
              </div>
              <div class="row inv--product-table-section">
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table">
                      <thead class="">
                      <tr>
                        <th scope="col">{{ 'S.No' | translate }}</th>
                        <th scope="col">{{ 'Items' | translate }}</th>
                        <th class="text-left" scope="col">{{ 'Qty' | translate }}</th>
                        <th class="text-left" scope="col">{{ 'Price' | translate }}</th>
                        <th class="text-left" scope="col">{{ 'Amount' | translate }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let p of selectedOrder.orderDetails.products;let i = index">
                        <td>{{ i + 1 }}</td>
                        <td>{{ p.product.title }}</td>
                        <td class="text-left">{{ p.qty }}</td>
                        <td class="text-left">{{ p.soldPrice }} <img height="18" src="assets/sr.svg"></td>
                        <td class="text-left">{{ p.qty * p.soldPrice }} <img height="18" src="assets/sr.svg"></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row mt-2 p-3">
                <div class="form-group w-100">
                  <label for="order-note">{{ 'Note' |translate }}</label>
                  <textarea name="order-note" [value]="selectedOrder.orderDetails.note" disabled class="form-control" id="order-note" rows="3"></textarea>
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-sm-5 col-12 order-sm-0 order-1">
                  <div class="inv--payment-info">
                    <div class="row">
                      <div class="col-sm-4 col-12">
                        <p>{{ 'Sub-Total:' | translate }} </p>
                      </div>
                      <div class="col-sm-8 col-12">
                        <p class="">{{ getSubtotal(selectedOrder) }} <img height="18" src="assets/sr.svg"></p>
                      </div>
                    </div>
                    <div class="row">
                      <div *ngIf="selectedOrder.merchantDetails.vatNumber" class="col-sm-4 col-12">
                        <p class=" inv-subtitle">{{ 'VAT' | translate }} </p>
                      </div>
                      <div *ngIf="selectedOrder.merchantDetails.vatNumber" class="col-sm-8 col-12">
                        <p class="">{{ calculateVat() | number:'1.2-2' }} <img height="18" src="assets/sr.svg"></p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4 col-12">
                        <p class=" inv-subtitle">{{ 'Discount:' | translate }} </p>
                      </div>
                      <div class="col-sm-8 col-12">
                        <p class="">{{ selectedOrder.orderDetails.discount ? selectedOrder.orderDetails.discount : 0 }} <img height="18" src="assets/sr.svg"></p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-4 col-12 grand-total-title">
                        <h4 class="">{{ 'Total' | translate }}</h4>
                      </div>
                      <div class="col-sm-8 col-12 grand-total-amount">
                        <h4 class="">{{ selectedOrder.orderDetails.amount }} <img height="18" src="assets/sr.svg"></h4>
                      </div>
                    </div>
                    <div class="row" *ngFor="let m of selectedOrder.orderDetails.moneyTransfers">
                      <div class="col-sm-4 col-12 grand-total-title font-14" *ngIf="getAmount(m.orderOrderNumber, m.amount, m.receiverType) != null">
                        <h6 [ngClass]="m.receiverType == 'MERCHANT_WALLET'? 'text-success' : 'text-danger'">{{ getTitle(m.receiverType) | translate }}</h6>
                      </div>
                      <div class="col-sm-8 col-12 grand-total-amount font-14" *ngIf="getAmount(m.orderOrderNumber, m.amount, m.receiverType) != null">
                        <h6 [ngClass]="m.receiverType == 'MERCHANT_WALLET'? 'text-success' : 'text-danger'">{{ getAmount(m.orderOrderNumber, m.amount, m.receiverType) | number:'1.0-2' }} <img height="18" src="assets/sr.svg"></h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-4">
              <div class="col-sm-12 col-12">
                <button class="btn btn-secondary my-2 mx-1" href="javascript:void(0);" (click)="shareOrder()" translate>Share Order</button>
                <button class="btn btn-danger my-2 mx-1" href="javascript:void(0);" (click)="printOrder()" translate>Print VAT Invoice</button>
                <button class="btn btn-success my-2 mx-1" href="javascript:void(0);" (click)="printReceipt()" translate>Print Receipt</button>
                <button class="btn btn-warning my-2 mx-1" *ngIf="selectedOrder && !isAccountant && selectedOrder.orderDetails.orderStatus === 'PENDING'" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#cancelModal'" translate>Cancel Order</button>
                <button class="btn btn-primary my-2 mx-1" *ngIf="selectedOrder && !isAccountant && (selectedOrder.orderDetails.orderStatus === 'PAID_LINK' || selectedOrder.orderDetails.orderStatus === 'PAID')" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#sentModal'" translate>Products sent to customer</button>
                <a *ngIf="selectedOrder && selectedOrder.refundPrice != null && selectedOrder.refundPrice != -1000.00 && !isAccountant && (selectedOrder.orderDetails.orderStatus === 'PAID_LINK' || selectedOrder.orderDetails.orderStatus === 'PAID' || selectedOrder.orderDetails.orderStatus === 'COMPLETED_ORDER' || selectedOrder.orderDetails.orderStatus === 'COMPLETED_INVOICE')" href="javascript:void(0);" data-toggle="modal" [attr.data-target]="'#refundModal'" class="text-danger" translate>Refund
                  the order</a>
                <a *ngIf="selectedOrder && selectedOrder.refundPrice == -1000.00 && !isAccountant && (selectedOrder.orderDetails.orderStatus === 'PAID_LINK' || selectedOrder.orderDetails.orderStatus === 'PAID' || selectedOrder.orderDetails.orderStatus === 'COMPLETED_ORDER' || selectedOrder.orderDetails.orderStatus === 'COMPLETED_INVOICE')" href="javascript:void(0);" class="text-danger" [attr.data-target]="'#cancelRefundModal'" data-toggle="modal" translate>Cancel the refund order</a>
                <a href="https://www.youtube.com/watch?v=s86A1Zli88Y" target="_blank" class="mx-2">
                  <svg width="15" height="15" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
                    <g id="Group">
                      <path id="Path" fill="#06209f" stroke="none"
                            d="M 683.015686 117.331543 C 526.902344 -38.973694 273.638733 -39.129089 117.331566 116.982361 C -38.973663 273.097717 -39.130989 526.363159 116.984306 682.670349 C 273.095764 838.975586 526.36322 839.130981 682.670349 683.017639 C 838.973694 526.906128 839.130981 273.636841 683.015686 117.331543 Z M 455.850311 653.819031 C 455.850311 659.991028 450.848602 664.988892 444.68042 664.988892 L 355.321472 664.988892 C 349.15332 664.988892 344.151642 659.991028 344.151642 653.819031 L 344.151642 322.097748 C 344.151642 315.925751 349.15332 310.927887 355.321472 310.927887 L 444.68042 310.927887 C 450.848602 310.927887 455.850311 315.923828 455.850311 322.097748 L 455.850311 653.819031 Z M 400.000977 264.571594 C 364.281158 264.571594 335.218811 235.513062 335.218811 199.791382 C 335.218811 164.073486 364.279266 135.009216 400.000977 135.009216 C 435.722656 135.009216 464.783112 164.071594 464.783112 199.791382 C 464.783112 235.513062 435.718811 264.571594 400.000977 264.571594 Z"/>
                    </g>
                    <g id="g1"/>
                  </svg>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
<app-share-panel [closeModalFn]="closeModal" #orderShareLinkModal [link]="orderShareLink" modalId="orderShareLink"></app-share-panel>

<!-- modal to cancel order -->
<div class="modal fade" id="cancelModal" tabindex="-1" role="dialog" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">{{ 'Cancel Order' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <p class="modal-text">{{ 'Do you want to cancel order of number' | translate }} {{ selectedOrder ? selectedOrder.orderDetails.orderNumber : '' }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>{{ 'No' | translate }}</button>
        <button (click)="cancelOrder(selectedOrder)" type="button" data-dismiss="modal" class="btn btn-primary" translate>{{ 'Yes' | translate }}</button>
      </div>
    </div>
  </div>
</div>
<!-- end of modal to cancel order -->

<!-- modal to mark order as completed -->
<div class="modal fade" id="sentModal" tabindex="-1" role="dialog" aria-labelledby="sentModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="sentModalLabel">{{ 'Products sent to customer' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <p class="modal-text">{{ 'Do you want to confirm the conversion of the order status to complete?' | translate }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>{{ 'No' | translate }}</button>
        <button (click)="markOrderCompleted(selectedOrder)" type="button" data-dismiss="modal" class="btn btn-primary" translate>{{ 'Yes' | translate }}</button>
      </div>
    </div>
  </div>
</div>
<!-- end of modal mark order as completed -->

<!-- modal to refund the order -->
<div class="modal fade" id="refundModal" tabindex="-1" role="dialog" aria-labelledby="refundModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="refundModalLabel">{{ 'Refund the order' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body" *ngIf="selectedOrder && selectedOrder.refundPrice != null">
        <p *ngIf="selectedOrder.refundPrice > 0" class="modal-text">{{ 'Do you want to refund this order? The refund fees is ' | translate }} {{ selectedOrder.refundPrice }} <img height="18" src="assets/sr.svg"></p>
        <p *ngIf="selectedOrder.refundPrice == 0" class="modal-text">{{ 'Do you want to refund this order? The refund fees is ' | translate }} {{ 'Free' | translate }}</p>

        <div class="mb-3">
          <label for="validationTextarea" translate>The refund reason</label>
          <textarea [(ngModel)]="refundReason" class="form-control is-invalid" id="validationTextarea" [placeholder]="'The refund reason' | translate" required></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>{{ 'No' | translate }}</button>
        <button (click)="refundOrderCompleted(selectedOrder)" type="button" data-dismiss="modal" class="btn btn-primary" translate>{{ 'Yes' | translate }}</button>
      </div>
    </div>
  </div>
</div>
<!-- end of modal refund order -->

<!-- modal to cancel refund the order -->
<div class="modal fade" id="cancelRefundModal" tabindex="-1" role="dialog" aria-labelledby="cancelRefundModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="cancelRefundModalLabel">{{ 'Cancel refund the order' | translate }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body" *ngIf="selectedOrder && selectedOrder.refundPrice != null">
        <p class="modal-text">{{ 'Do you want to cancel refunding this order?' | translate }}</p>
      </div>
      <div class="modal-footer">
        <button class="btn" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>{{ 'No' | translate }}</button>
        <button (click)="cancelRefundOrder(selectedOrder)" type="button" data-dismiss="modal" class="btn btn-primary" translate>{{ 'Yes' | translate }}</button>
      </div>
    </div>
  </div>
</div>
<!-- end of modal refund order -->

<!-- modal searching ... -->
<div class="modal fade" #searchModal tabindex="-1" role="dialog" aria-labelledby="sentModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <p class="modal-text" translate>Searching ...</p>
      </div>
    </div>
  </div>
</div>
<!-- end of modal mark order as completed -->
